<template>
  <div>
    <ValidationObserver ref="form">
      <form @submit.prevent="handleSubmit">
          <div class="vx-row">
            <div class="vx-col w-full">
              <h3 class="mb-4"><strong>Información general</strong></h3>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="vx-col w-full mb-3">
                <label><strong>Nombre</strong></label>
                <p>{{ coupon.name }}</p>
                </div>
            </div>

             <div class="vx-col md:w-1/2 w-full">
              <div class="vx-col w-full mb-3">
                <label><strong>Descripción</strong></label>
                <p>{{ coupon.description }}</p>
            </div>
             </div>


              <div class="vx-col md:w-1/2 w-full">
             <div class="vx-col w-full mb-3">
                <label><strong>Categorías</strong></label>
                <p>{{ coupon.Name_dish_group }}</p>
            </div>

          </div>

             <div class="vx-col md:w-1/2 w-full">
              <div class="vx-col w-full mb-3">
                <label><strong>Cantidad a consumir</strong></label>
                <p>{{ coupon.amount }}</p>
            </div>
            </div>

            <div class="vx-col md:w-1/2 w-full">
              <div class="vx-col w-full mb-3">
                <label><strong>Desde</strong></label>
                <p>{{ coupon.starting_at }}</p>
            </div>
            </div>

            <div class="vx-col md:w-1/2 w-full">
             <div class="vx-col w-full mb-3">
                <label><strong>Hasta</strong></label>
                <p>{{ coupon.finishing_at }}</p>
            </div>
            </div>

            <div class="vx-col md:w-1/2 w-full">
             <div class="vx-col w-full mb-3">
                <label><strong>Producto gratis</strong></label>
                <p>{{ coupon.free_product_name }}</p>
            </div>
            </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>



import draggable from 'vuedraggable';
import { mapActions, mapGetters } from 'vuex';

export default {
props: {
    coupon: {
      type: Object,
      required: true,
    },
  },
  components: {
    draggable,
  },
  created() {
    this.getDishGroups(this.currentRestaurant);
  },
  data () {
    return {
      name: '',
      description: '',
      id_dish_group:0,
      amount_to_complete:0,
      starting_at:'',
      ending_at:'',
    };
  },
  mounted () {
    this.isMounted = true;
  },
  computed: {
    ...mapGetters({
      itemsSales: 'getCoupons',
      currentRestaurant: 'getCurrentRestaurant',
      dishGroupList: 'getDishGroups',
    }),



    data () {
      const items = this.itemsDishes;
      const results = [];

      items.forEach(function (item, index) {
          const coupon = {
            id: items[index].id,
            name: items[index].name,
            description: items[index].description,
            id_dish_group:items[index].id_dish_group,
            amount_to_complete:items[index].amount_to_complete,
            starting_at:items[index].starting_at,
            ending_at:items[index].ending_at,
          };
          results.push(coupon);
      }, items);

      return results;
    },
  },
  methods: {
    ...mapActions({
      getDishGroups:'getDishGroups',
      createCoupon:'createCoupon',
      refreshSales: 'refreshCoupons',
      language: 'getCurrentLanguagePublic',
    }),
    handleSubmit () {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          setTimeout(() => {
            let textAux = '';
            const errors = this.$refs.form.errors;
            Object.keys(errors).forEach((key) => {
              const error = errors[key];
              if (error.length) {
                error.forEach(function (text) {
                  textAux += `<p>${text}</p>`;
                });
              }
            });
            this.$store.commit('notifications', {
              title: 'Existen errores en el formulario.',
              color: 'danger',
              text: textAux,
            });
            this.$store.commit('showNotifications', true);
          }, 100);
          return;
        }

        this.submitted = true;

        const formData = this.createFormData();

        this.createCoupon({ coupon: formData, language: this.language });


        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    },

    createFormData () {
      const data = new FormData();
      //const data = this.$refs.images.getFormData();

      data.append('name', this.name);
      data.append('restaurant_id',this.currentRestaurant)
      data.append('description', this.description);
      data.append('id_dish_group', this.id_dish_group);
      data.append('amount_to_complete', this.amount_to_complete);
      data.append('starting_at', this.starting_at);
      data.append('finishing_at', this.ending_at);
      return data;
    },
  },
};
</script>
<style></style>
